import {put, takeLatest, call} from 'redux-saga/effects';
import * as optionService from "../../../../services/optionService";
import {
    DELETE_OPTIONS,
    DELETE_OPTIONS_SUCCESS,
    DELETE_OPTIONS_ERROR
}
    from "../../../actions/menu/options";

function* deleteOptionsSaga(action) {
    try {
        yield call(optionService.DeleteOptions, action.payload)
        
        yield put({
            type: DELETE_OPTIONS_SUCCESS,
            payload: action.payload._ids
        });

    } catch (error) {
        yield put({
            type: DELETE_OPTIONS_ERROR,error: error.data
        });
    }
}


export function* deleteOptionsSagaWatcher() {
    yield takeLatest(DELETE_OPTIONS, deleteOptionsSaga);
}